import { render } from "./FirebaseIntegrationSettings.vue?vue&type=template&id=4dd0b159"
import script from "./FirebaseIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./FirebaseIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__